module.exports = __webpack_public_path__ + "static/img/storageFu2.f61c816.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/storageFu2.png
// module id = B0Mj
// module chunks = 2